// Entry point — delegates to the feature folder.
// App.tsx continues to import from './pages/PersonalTest' without any change.
import PersonalTestPage from './PersonalTest/index';
export default PersonalTestPage;
